import React, {
  CSSProperties,
  DetailedHTMLProps,
  LabelHTMLAttributes,
} from 'react'
import { Controller, FieldValues } from 'react-hook-form'

import s from './styles.module.scss'

import { ControlledCommons } from '../input-text/input-text'
import { EmptyEditImage } from '../../common/empty-edit-image'
import { Image } from '../../../components/atoms/containers/Image'

export interface IControlledImageFieldProps<T extends FieldValues>
  extends ControlledCommons<T> {
  image?: string
  style?: CSSProperties
  disabled?: boolean
  label?: string
  labelProps?: DetailedHTMLProps<
    LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  >
  uploadFileToS3: (file: File) => Promise<any>
}

function ControlledImageField<T extends FieldValues>({
  style = {},
  control,
  rules,
  name,
  disabled = false,
  label,
  labelProps,
  uploadFileToS3,
}: IControlledImageFieldProps<T>) {
  return (
    <Controller
      control={control}
      rules={rules}
      render={({ field }) => (
        <div className={s.containerPicture} style={style}>
          {label && <label {...labelProps}>{label}</label>}
          <label className={s.containerImage} htmlFor='file-input'>
            {field.value ? (
              <Image
                src={field.value as string}
                alt='Photo de profile'
                type='cover'
                round
              />
            ) : (
              <EmptyEditImage />
            )}
          </label>
          {!disabled && (
            <input
              id='file-input'
              type='file'
              accept='image/*'
              style={{ display: 'none' }}
              onChange={async (e) => {
                if (e.target.files) {
                  const url = await uploadFileToS3(e.target.files[0])
                  field.onChange(url)
                }
              }}
            />
          )}
        </div>
      )}
      name={name}
    />
  )
}

export default ControlledImageField
